import { useMutation, useQueryClient } from 'react-query'
import { QueryNames } from 'Hooks/api/queryNames'
import { toast } from 'react-toastify'
import { AppNotification } from 'Utils/types/appNotification'
import { addMerchantToProgram } from 'Services/JOONAdmin/merchantService'

export const useUpsertMerchantToProgramQuery = () => {
  const queryClient = useQueryClient()

  return useMutation([QueryNames.AddProgramToMerchant], addMerchantToProgram, {
    onSuccess: (response) => {
      if (response.success) {
        queryClient.invalidateQueries([QueryNames.GetBenefitProgramMerchants])
        toast.success(AppNotification.AddProgramToMerchantSuccess)
      } else {
        toast.error(`${AppNotification.AddProgramToMerchantFailure} ${response.message}`)
      }
    },
    onError: () => {
      toast.error(AppNotification.AddProgramToMerchantFailure)
    }
  })
}
